const Card = (props) => {
  return <div {...props} className="login-form"></div>;
};

export default Card;
